import React from 'react';
import { useSelector } from 'react-redux';
import Header from '../../Components/Header/Header';
import { Container, Box, Typography, Divider } from '@mui/material';
import { RootState } from '../../Redux/Store';
import SubscriptionSection from './SubscriptionSection';
import StripeConnectionSection from './StripeConnectionSection';
import PaymentMethodSection from './PaymentMethodSection';
import StoreProfileSection from './StoreProfileSection';
import ClerkSection from './ClerkSection';
import StoreCreationSection from './StoreCreationSection';
import StoreDeletionSection from './StoreDeletionSection';

/**
 * 店舗管理画面。要件定義 0001 / feast-fe ADR 0009・0010・0016。
 * 店舗単位の管理機能を集約するページ。企業・店舗情報の編集（管理者のみ）・
 * 店員管理（招待・ロール変更・削除）・アカウント削除リクエストを配置する。
 */
const StoreManagement: React.FC = () => {
  // サブスクリプション状況は経営情報のため MANAGER のみに見せる（BE も 403 で弾く）。
  const isManager = localStorage.getItem('role') === 'ROLE_MANAGER';
  return (
    <>
      <Header />
      <Container component="main" maxWidth="sm">
        <Box sx={{ mt: 3, mb: 6 }}>
          <Typography variant="h5" gutterBottom>
            店舗管理
          </Typography>
          {isManager && <SubscriptionSection />}
          {/* Stripe Connect 連携（予約の事前決済）。経営情報のため MANAGER のみ（BE も MANAGER 認証）。ADR 0039 */}
          {isManager && <StripeConnectionSection />}
          <ClerkSection />
          <Divider sx={{ my: 3 }} />
          <PaymentMethodSection />
          <Divider sx={{ my: 3 }} />
          <StoreProfileSection />
          <Divider sx={{ my: 3 }} />
          <StoreCreationSection />
          <Divider sx={{ my: 3 }} />
          <StoreDeletionSection />
        </Box>
      </Container>
    </>
  );
};

export default StoreManagement;
